import React, { useState } from "react";
import { Button, Modal, Table, Tag } from "antd";
import { FaRegEdit } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import InstanceTable from "./InstanceTable";
import Ec2FormTable from "./Ec2FormTable";
import { useEc2ZustandStore } from "../../../../zustand/store/useEc2ZustandStore";

const ClientInfraTable = ({ clientInfraConfigData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { ec2ZustandEditData, setEc2ZustandEditData } = useEc2ZustandStore(); // Access the Zustand setter

  const handleEdit = (record) => {
    setEc2ZustandEditData(record); // Set the record being edited
    setIsModalOpen(true); // Open modal
  };

  const handleCancel = () => {
    setEc2ZustandEditData(null);
    setIsModalOpen(false);
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    //   {
    //     title: "Project ID",
    //     dataIndex: "projectId",
    //     key: "projectId",
    //   },
    {
      title: "Region",
      dataIndex: "region",
      key: "region",
    },
    {
      title: "Client Name",
      dataIndex: "clientName",
      key: "costPerHour",
    },

    //   {
    //     title: "Instance Type",
    //     dataIndex: "instanceType",
    //     key: "instanceType",
    //   },
    //   {
    //     title: "Availability Zone",
    //     dataIndex: "availabilityZone",
    //     key: "availabilityZone",
    //   },
    //   {
    //     title: "VPC ID",
    //     dataIndex: "vpcId",
    //     key: "vpcId",
    //   },
    //   {
    //     title: "Subnet ID",
    //     dataIndex: "subnetId",
    //     key: "subnetId",
    //   },
    {
      title: "GPU",
      dataIndex: "GPU",
      key: "GPU",
      width: 20,
    },
    {
      title: "CPU",
      dataIndex: "cpu",
      key: "cpu",
    },
    {
      title: "Memory (GB)",
      dataIndex: "memory",
      key: "memory",
      // render: (memory) => `${memory / 1024} GB`,
    },

    {
      title: "Cost Per Hour ($)",
      dataIndex: "costPerHour",
      key: "costPerHour",
      render: (item) => parseFloat(item),
    },
    //   {
    //     title: "Created At",
    //     dataIndex: "created_at",
    //     key: "created_at",
    //   },
    {
      title: "Instance Type",
      dataIndex: "instanceType",
      key: "instanceType_",
    },
    {
      title: "Infra Type",
      dataIndex: "infraType",
      key: "infraType",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "_status_",
      render: (text) => <Tag className=" capitalize">{text || "none"}</Tag>, // Render as link
    },
    {
      title: "Action",
      dataIndex: "InsEdit",
      key: "memory_",
      render: (_, record) => (
        <button onClick={() => handleEdit(record)}>
          <FiEdit color="green" size={14} />{" "}
        </button>
      ),
    },
  ];
  return (
    <>
      <Modal
        title="Update Instance"
        open={isModalOpen}
        footer={null}
        width={"80%"}
        destroyOnClose
        onCancel={handleCancel}
      >
        Client Name:{" "}
        <Tag color="pink" className=" capitalize">
          {ec2ZustandEditData?.clientName}
        </Tag>
        <div className="mb-3"></div>
        <Ec2FormTable />
      </Modal>
      <Table
        bordered
        scroll={{ x: 600 }}
        className="user-table-theme"
        dataSource={clientInfraConfigData}
        columns={columns}
      />
    </>
  );
};

export default ClientInfraTable;
